<template>
  <div class="filter-box">
    <van-search
      v-model="searchCalendar"
      @click="showCalendar = true"
      :disabled="true"
      shape="round"
      :showAction="showAction"
      placeholder="查询日期"
      @search="onSearch"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <van-calendar
      v-model="showCalendar"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="[searchDate[0].toDate(), searchDate[1].toDate()]"
      type="range"
      :allow-same-day="true"
      @confirm="onCalendarConfirm"
    />
  </div>
</template>

<script>
import moment from "moment";
import { Search, Calendar } from "vant";
export default {
  name: "CanlendarSearch",
  components: {
    [Calendar.name]: Calendar,
    [Search.name]: Search,
  },
  props: {
    initDate: {
      type: Array,
      default: () => [],
    },
    showAction: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    searchCalendar() {
      let date = [];
      if (this.searchDate && this.searchDate.length) {
        date.push(this.searchDate[0].format("YYYY/MM/DD"));
        date.push(this.searchDate[1].format("YYYY/MM/DD"));
      }
      return date.join(" - ");
    },
  },
  data() {
    return {
      showSearch: true,
      showCalendar: false,
      searchDate: [moment(), moment()],
      minDate: moment()
        .subtract(1, "years")
        .toDate(),
      maxDate: moment()
        .add(1, "years")
        .toDate(),
    };
  },
  created() {
    this.searchDate[0] =
      this.initDate && this.initDate[0] ? this.initDate[0] : moment();
    this.searchDate[1] =
      this.initDate && this.initDate[1] ? this.initDate[1] : moment();
  },
  methods: {
    onCalendarConfirm(e) {
      const startDate = moment(e[0]).format("YYYY-MM-DD");
      const endDate = moment(e[1]).format("YYYY-MM-DD");
      this.params = {
        startDate: startDate,
        endDate: endDate,
      };
      this.searchDate = [moment(e[0]), moment(e[1])];
      this.$emit("update", this.params);
      this.showCalendar = false;
    },
    onSearch() {
      this.params = {
        startDate: this.searchDate
          ? this.searchDate[0].format("YYYY-MM-DD")
          : "",
        endDate:
          this.searchDate && this.searchDate.length > 1
            ? this.searchDate[1].format("YYYY-MM-DD")
            : "",
      };
      this.$emit("update", this.params);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-field__control:disabled {
  color: #000;
  text-align: center;
  font-size: 15px;
}
/deep/.van-search__content--round {
  background: #fff;
}
/deep/.van-search {
  background: transparent;
  padding: 0;
}
</style>
